import { render, staticRenderFns } from "./AccountSubmittedView.vue?vue&type=template&id=708cd4e9&"
import script from "./AccountSubmittedView.vue?vue&type=script&lang=js&"
export * from "./AccountSubmittedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports